import findPlanByLegacyId from 'utils/pivot/plan/findPlanByLegacyId'
import { toId } from 'utils/pivot/product'
import { IS_AGENT } from 'core/constants/environment'
import { recEngineParseDuration } from 'utils/pivot/recEngineParser'

function findPlanByPlanType(plansSTM, plans, planType) {
  planType = +toId(planType)
  return plansSTM.find(id => plans[id].productId === planType)
}

function orderByPlanId(planIds, plans, plansSTM) {
  const result = []

  for (const idPlan of planIds) {
    const response = IS_AGENT
      ? { id: plansSTM.find(id => id === idPlan) }
      : findPlanByLegacyId(plansSTM, plans, idPlan)
    if (response.id) {
      result.push(response.id)

      if (result.length === 3) {
        return result
      }
    }
  }

  return result
}

function getRecommendedPlanIds({ recEngine, periods, plans }) {
  let planIds = []
  let currentPolicy = 1
  Object.keys(recEngine).forEach(key => {
    if (periods.includes(+key)) {
      planIds = planIds.concat(recEngine[key].map(ids => +ids))
    }

    const [policy, parsedPeriod] = key.split('x')
    if (periods.includes(+parsedPeriod)) {
      if (currentPolicy > +policy) {
        currentPolicy = +policy
        planIds = recEngine[key]
      }
    }

    if (key === 'default' && planIds.length === 0) {
      const defaultPlans = recEngine[key]
      defaultPlans.forEach(planId => {
        if (
          plans[planId] &&
          Object.keys(plans[planId].durations).find(d => periods.includes(+d))
        ) {
          planIds.push(
            planId.includes(':') ? +recEngineParseDuration(planId.split(':')[1]) : +planId
          )
        }
      })
    }
  })
  return planIds
}

function orderByType(suggestionPlanTypes, plans, plansSTM) {
  return suggestionPlanTypes.reduce((acc, planType) => {
    const planId = findPlanByPlanType(plansSTM, plans, planType.toLowerCase())
    if (planId) {
      acc.push(planId)
    }

    return acc
  }, [])
}

function orderPlansByRecEngine({ recEngine, plans, plansSTM, periods }) {
  let recommend

  if (IS_AGENT) {
    const planIds = getRecommendedPlanIds({ recEngine, periods, plans })
    recommend = planIds ? orderByPlanId(planIds, plans, plansSTM) : []
  } else {
    recommend =
      recEngine.order_by_plan_id.length > 0
        ? orderByPlanId(recEngine.order_by_plan_id, plans, plansSTM)
        : orderByType(recEngine.order_by_plan_type, plans, plansSTM)
  }

  return recommend
}

export default orderPlansByRecEngine
